"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._FormBuilder = exports.SAFormBuilderFieldType = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ = require("..");
var _Form = _interopRequireDefault(require("../Form"));
var _Dropdown = _interopRequireDefault(require("../Dropdown"));
var _ReactDatePicker = _interopRequireDefault(require("../ReactDatePicker"));
var _class2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* babel-plugin-inline-import '../Form/info.svg' */
var infoButton = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGQ9Ik03IC41ODNhNi40MTcgNi40MTcgMCAxMTAgMTIuODM0QTYuNDE3IDYuNDE3IDAgMDE3IC41ODN6bTAgLjc1NWE1LjY2MiA1LjY2MiAwIDEwMCAxMS4zMjRBNS42NjIgNS42NjIgMCAwMDcgMS4zMzh6bS44MDIgNC44NnY0LjAxSDYuMTk4di00LjAxaDEuNjA0ek03IDMuNzkyYS44MDIuODAyIDAgMTEwIDEuNjA0LjgwMi44MDIgMCAwMTAtMS42MDR6IiBpZD0iYSIvPjwvZGVmcz48dXNlIGZpbGw9IiNCOUMxQ0IiIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI2EiLz48L3N2Zz4=";
var SAFormBuilderFieldType = /*#__PURE__*/function (SAFormBuilderFieldType) {
  SAFormBuilderFieldType["Radio"] = "radio";
  SAFormBuilderFieldType["Checkbox"] = "checkbox";
  SAFormBuilderFieldType["Text"] = "text";
  SAFormBuilderFieldType["DropDown"] = "dropdown";
  SAFormBuilderFieldType["Hierarchy"] = "hierarchy";
  SAFormBuilderFieldType["Datepicker"] = "datepicker";
  SAFormBuilderFieldType["Timepicker"] = "timepicker";
  return SAFormBuilderFieldType;
}({});
exports.SAFormBuilderFieldType = SAFormBuilderFieldType;
var withHandleError = function withHandleError(Component) {
  return /*#__PURE__*/function (_React$PureComponent) {
    _inherits(withHandleError, _React$PureComponent);
    var _super = _createSuper(withHandleError);
    function withHandleError() {
      var _this;
      _classCallCheck(this, withHandleError);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "state", {
        error: undefined
      });
      return _this;
    }
    _createClass(withHandleError, [{
      key: "componentDidCatch",
      value: function componentDidCatch(err) {
        console.error(err);
        this.setState({
          error: 'Unable to display contact log form'
        });
      }
    }, {
      key: "render",
      value: function render() {
        if (this.state.error) return /*#__PURE__*/_react.default.createElement("p", null, this.state.error);
        return /*#__PURE__*/_react.default.createElement(Component, this.props);
      }
    }]);
    return withHandleError;
  }(_react.default.PureComponent);
};
var _FormBuilder = /*#__PURE__*/function (_Component) {
  _inherits(_FormBuilder, _Component);
  var _super2 = _createSuper(_FormBuilder);
  function _FormBuilder(props) {
    var _this2;
    _classCallCheck(this, _FormBuilder);
    _this2 = _super2.call(this, props);
    _defineProperty(_assertThisInitialized(_this2), "shouldDisplay", function (condition) {
      var values = _this2.state.values;
      if (!condition) return true;
      var field = values[condition.field];
      var value = condition.value || values[condition.compareField];
      switch (condition.comparator) {
        case '!exists':
          return Array.isArray(field) ? !field.length : !field;
        case 'exists':
          return Array.isArray(field) ? !!field.length : !!field;
        case '=':
          return Array.isArray(field) ? !!field.find(function (f) {
            return (f.data || f) === value;
          }) : field === value;
        case '!=':
          return Array.isArray(field) ? field.find(function (f) {
            return (f.data || f) === value;
          }) : field !== value;
        case '<':
          return Array.isArray(field) ? field.find(function (f) {
            return Number(f.data || f) < Number(value);
          }) : Number(field) < Number(value);
        case '>':
          return Array.isArray(field) ? field.find(function (f) {
            return Number(f.data || f) > Number(value);
          }) : Number(field) > Number(value);
        case 'begins-with':
          return Array.isArray(field) ? field.find(function (f) {
            return (f.data || f).indexOf(value) === 0;
          }) : field.indexOf(value) === 0;
        default:
          return true;
      }
    });
    _defineProperty(_assertThisInitialized(_this2), "Common", function (_ref) {
      var children = _ref.children,
        comments = _ref.comments,
        name = _ref.name,
        text = _ref.text,
        info = _ref.info,
        condition = _ref.condition;
      var currentComments = _this2.state.comments;
      var onChange = _this2.props.onChange;
      if (!_this2.shouldDisplay(condition)) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sa-form-field"
      }, text ? /*#__PURE__*/_react.default.createElement("div", {
        className: "sa-form-field-title"
      }, /*#__PURE__*/_react.default.createElement("span", null, text), info && /*#__PURE__*/_react.default.createElement(_.TriggeredPopup, {
        closeOnClickOutside: true,
        fromRight: true,
        trigger: /*#__PURE__*/_react.default.createElement("img", {
          className: "sa-form-field-info",
          alt: "Info",
          src: infoButton
        })
      }, info)) : null, children, comments && /*#__PURE__*/_react.default.createElement(_.Input, {
        onBlur: function onBlur() {
          return onChange === null || onChange === void 0 ? void 0 : onChange("".concat(name, "-comments"), _this2.state.comments[name]);
        },
        textarea: true,
        rows: 3,
        name: "Comments text area",
        placeholder: "Comments",
        value: currentComments[name] || '',
        className: "sa-form-field-comments",
        onChange: function onChange(value) {
          return _this2.setState({
            comments: _objectSpread(_objectSpread({}, currentComments), {}, _defineProperty({}, name, value))
          });
        }
      }));
    });
    _defineProperty(_assertThisInitialized(_this2), "onSubmit", function (event) {
      var _this2$state = _this2.state,
        data = _this2$state.data,
        values = _this2$state.values,
        comments = _this2$state.comments;
      var blob = Object.keys(values).map(function (name) {
        var field = _this2.props.data.fields.find(function (field) {
          return field.name === name;
        });
        var value = values[name];
        if (value && (field.type === SAFormBuilderFieldType.DropDown || field.type === SAFormBuilderFieldType.Hierarchy)) {
          value = Array.isArray(values[name]) ? values[name] : data[name];
          value = _this2.getDropdownValue(value);
        }
        return {
          name: name,
          value: value,
          comments: comments[name]
        };
      });
      if (_this2.props.preventDefault && event) {
        event.preventDefault();
      }
      _this2.props.onSubmit && _this2.props.onSubmit(blob);
    });
    _defineProperty(_assertThisInitialized(_this2), "onCancel", function () {
      _this2.props.onCancel && _this2.props.onCancel();
    });
    _defineProperty(_assertThisInitialized(_this2), "getDropdownValue", function (values) {
      if (Array.isArray(values)) {
        return values.map(function (v) {
          return v.data;
        });
      }
      return values;
    });
    _defineProperty(_assertThisInitialized(_this2), "onSubmitError", function (invalid) {
      requestAnimationFrame(function () {
        var _invalid$0$getRef, _invalid$0$getRef$clo;
        (_invalid$0$getRef = invalid[0].getRef()) === null || _invalid$0$getRef === void 0 ? void 0 : (_invalid$0$getRef$clo = _invalid$0$getRef.closest(".sa-form-field")) === null || _invalid$0$getRef$clo === void 0 ? void 0 : _invalid$0$getRef$clo.scrollIntoView();
      });
    });
    _this2.state = {
      values: _FormBuilder.getInitialValuesFromProps(props),
      data: {},
      comments: {}
    };
    return _this2;
  }
  _createClass(_FormBuilder, [{
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        data = _this$props.data,
        renderSubmit = _this$props.renderSubmit,
        _onChange = _this$props.onChange;
      var title = data.title || this.props.title;
      var values = this.state.values;
      return /*#__PURE__*/_react.default.createElement(_Form.default, {
        onSubmit: this.onSubmit,
        onSubmitError: this.onSubmitError
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sa-form-content"
      }, title && /*#__PURE__*/_react.default.createElement("h1", null, title), data.fields.map(function (field, i) {
        var name = field.name;
        return function () {
          switch (field.type) {
            case SAFormBuilderFieldType.Text:
              return /*#__PURE__*/_react.default.createElement(_this3.Common, _extends({
                key: i
              }, field), /*#__PURE__*/_react.default.createElement(_.Input, {
                onBlur: function onBlur() {
                  return _onChange === null || _onChange === void 0 ? void 0 : _onChange(name, _this3.state.values[name]);
                },
                type: "text",
                name: field.name,
                label: field.label,
                textarea: field.multiline,
                rows: field.rows,
                required: field.required,
                placeholder: field.placeholder,
                value: values[name],
                onChange: function onChange(value) {
                  return _this3.setState({
                    values: _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, name, value))
                  });
                }
              }));
            case SAFormBuilderFieldType.Checkbox:
              {
                var selectedValues = values[name];
                return /*#__PURE__*/_react.default.createElement(_this3.Common, field, field.options.map(function (value, i) {
                  return /*#__PURE__*/_react.default.createElement(_.Checkbox, {
                    key: "".concat(i, "-").concat(value),
                    square: true,
                    label: value,
                    checked: selectedValues.includes(value),
                    onChange: function onChange(checked) {
                      return _this3.setState({
                        values: _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, name, checked ? [].concat(_toConsumableArray(selectedValues), [value]) : selectedValues.filter(function (v) {
                          return v !== value;
                        })))
                      }, function () {
                        return _onChange === null || _onChange === void 0 ? void 0 : _onChange(name, _this3.state.values[name]);
                      });
                    }
                  });
                }));
              }
            case SAFormBuilderFieldType.Radio:
              return /*#__PURE__*/_react.default.createElement(_this3.Common, field, field.options.map(function (value, i) {
                return /*#__PURE__*/_react.default.createElement(_.Checkbox, {
                  key: "".concat(i, "-").concat(value),
                  label: value,
                  checked: values[name] === value,
                  onChange: function onChange(checked) {
                    return checked && _this3.setState({
                      values: _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, name, value))
                    }, function () {
                      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(name, _this3.state.values[name]);
                    });
                  }
                });
              }));
            case SAFormBuilderFieldType.DropDown:
              {
                var _selectedValues = values[name];
                return /*#__PURE__*/_react.default.createElement(_this3.Common, field, /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
                  filter: field.filter,
                  options: field.options,
                  value: values[name],
                  placeholder: field.placeholder,
                  label: field.label,
                  maxFilterOptions: field.maxFilterOptions,
                  required: field.required,
                  preventDefaultInputOnEnterKey: _this3.props.preventDefault,
                  onChange: function onChange(option) {
                    var isArray = Array.isArray(_selectedValues);
                    _this3.setState({
                      values: _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, name, isArray ? [].concat(_toConsumableArray(_selectedValues), [option]) : option.label)),
                      data: _objectSpread(_objectSpread({}, _this3.state.data), {}, _defineProperty({}, name, isArray ? [].concat(_toConsumableArray(_selectedValues), [option]) : option.data))
                    }, function () {
                      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(name, _this3.getDropdownValue(_this3.state.data[name]));
                    });
                  },
                  onDeleteTag: function onDeleteTag(option) {
                    _this3.setState({
                      values: _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, name, values[name].filter(function (v) {
                        return v.label !== option.label;
                      }))),
                      data: _objectSpread(_objectSpread({}, _this3.state.data), {}, _defineProperty({}, name, _this3.state.data[name].filter(function (v) {
                        return v.data !== option.data;
                      })))
                    }, function () {
                      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(name, _this3.getDropdownValue(_this3.state.data[name]));
                    });
                  }
                }));
              }
            case SAFormBuilderFieldType.Hierarchy:
              {
                var _selectedValues2 = values[name];
                return /*#__PURE__*/_react.default.createElement(_this3.Common, field, /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
                  filter: field.filter,
                  options: field.options,
                  value: values[name],
                  placeholder: field.placeholder,
                  label: field.label,
                  maxFilterOptions: field.maxFilterOptions,
                  required: field.required,
                  preventDefaultInputOnEnterKey: _this3.props.preventDefault,
                  onChange: function onChange(option) {
                    var isArray = Array.isArray(_selectedValues2);
                    _this3.setState({
                      values: _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, name, isArray ? [].concat(_toConsumableArray(_selectedValues2), [option]) : option.label)),
                      data: _objectSpread(_objectSpread({}, _this3.state.data), {}, _defineProperty({}, name, isArray ? [].concat(_toConsumableArray(_selectedValues2), [option]) : option.data))
                    }, function () {
                      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(name, _this3.getDropdownValue(_this3.state.data[name]));
                    });
                  },
                  onDeleteTag: function onDeleteTag(option) {
                    _this3.setState({
                      values: _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, name, values[name].filter(function (v) {
                        return v.label !== option.label;
                      }))),
                      data: _objectSpread(_objectSpread({}, _this3.state.data), {}, _defineProperty({}, name, _this3.state.data[name].filter(function (v) {
                        return v.data !== option.data;
                      })))
                    }, function () {
                      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(name, _this3.getDropdownValue(_this3.state.data[name]));
                    });
                  }
                }));
              }
            case SAFormBuilderFieldType.Datepicker:
              {
                return /*#__PURE__*/_react.default.createElement(_this3.Common, _extends({
                  key: i
                }, field), /*#__PURE__*/_react.default.createElement(_ReactDatePicker.default, {
                  title: field.name,
                  required: field.required,
                  value: values[name],
                  handleChange: function handleChange(value) {
                    _this3.setState({
                      values: _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, name, value))
                    }, function () {
                      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(name, _this3.state.values[name]);
                    });
                  },
                  showMonthDropdown: true,
                  showYearDropdown: true,
                  dropdownMode: "select",
                  label: field.label,
                  onBlur: function onBlur() {
                    return _onChange === null || _onChange === void 0 ? void 0 : _onChange(name, _this3.state.values[name]);
                  }
                }));
              }
            case SAFormBuilderFieldType.Timepicker:
              {
                return /*#__PURE__*/_react.default.createElement(_this3.Common, _extends({
                  key: i
                }, field), /*#__PURE__*/_react.default.createElement(_.Input, {
                  onBlur: function onBlur() {
                    return _onChange === null || _onChange === void 0 ? void 0 : _onChange(name, _this3.state.values[name]);
                  },
                  name: field.name,
                  required: field.required,
                  value: values[name],
                  onChange: function onChange(value) {
                    return _this3.setState({
                      values: _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, name, value))
                    });
                  },
                  type: "time",
                  label: field.label
                }));
              }
            default:
              return null;
          }
        }();
      })), renderSubmit ? renderSubmit() : /*#__PURE__*/_react.default.createElement("div", {
        className: "sa-form-controls"
      }, /*#__PURE__*/_react.default.createElement(_.Button, {
        round: true,
        styling: "secondary",
        onClick: this.onCancel
      }, "Cancel"), /*#__PURE__*/_react.default.createElement(_.Button, {
        round: true,
        styling: "primary",
        onClick: this.onSubmit
      }, "Submit")));
    }
  }], [{
    key: "convertToArray",
    value: function convertToArray(val) {
      return Array.isArray(val) ? val : [val];
    }
  }]);
  return _FormBuilder;
}(_react.Component);
exports._FormBuilder = _FormBuilder;
_class2 = _FormBuilder;
_defineProperty(_FormBuilder, "getInitialValuesFromProps", function (props) {
  var fields = props.data.fields;
  var defaultValues = props.defaultValues;
  var names = fields.map(function (field) {
    return field.name;
  });
  if (_toConsumableArray(new Set(names)).length < names.length) throw new Error('No duplicate names allowed');
  return fields.reduce(function (prevFields, field) {
    var defaultValue = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues[field.name];
    switch (field.type) {
      case SAFormBuilderFieldType.Text:
      case SAFormBuilderFieldType.Radio:
      case SAFormBuilderFieldType.Datepicker:
      case SAFormBuilderFieldType.Timepicker:
        return _objectSpread(_objectSpread({}, prevFields), {}, _defineProperty({}, field.name, defaultValue !== null && defaultValue !== void 0 ? defaultValue : ''));
      case SAFormBuilderFieldType.Checkbox:
        return _objectSpread(_objectSpread({}, prevFields), {}, _defineProperty({}, field.name, defaultValue ? _class2.convertToArray(defaultValue) : []));
      case SAFormBuilderFieldType.DropDown:
        return _objectSpread(_objectSpread({}, prevFields), {}, _defineProperty({}, field.name, field.multi ? defaultValue ? _class2.convertToArray(defaultValue) : [] : defaultValue !== null && defaultValue !== void 0 ? defaultValue : ''));
      case SAFormBuilderFieldType.Hierarchy:
        return _objectSpread(_objectSpread({}, prevFields), {}, _defineProperty({}, field.name, field.multi ? defaultValue ? _class2.convertToArray(defaultValue) : [] : defaultValue !== null && defaultValue !== void 0 ? defaultValue : ''));
      default:
        throw new Error('Unknown field type');
    }
  }, {});
});
var FormBuilder = withHandleError(_FormBuilder);
var _default = FormBuilder;
exports.default = _default;